<template>
  <card
    :id="`resource-component_${resourceType}-${name}_form`"
    :class="`resource-component_${name} position-relative`"
    :title="trans(`models.${picked.meta.resourceType}.name.singular`) + ' speichern'"
  >
    <slot name="top" />
    <resource-form
      :key="picked.data.id"
      :action-title="trans(`models.${picked.meta.resourceType}.name.singular`) + ' speichern'"
      :errors="errors"
      :options="{ relation: resource.data.collections[name].meta.relationInfo, parentResource: resource }"
      :resource="picked"
      @updateFromApi="updateData"
    ></resource-form>
    <slot name="bottom" />
  </card>
</template>

<script>
import Card from '@kanrisha/components/Base/Card';
import ResourceForm from '@kanrisha/components/ResourceForm';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    Card,
    ResourceForm,
  },
  props: {
    name: { type: String, default: '' },
    resource: { type: Object, default: () => {} },
    picked: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['updateData'],
  setup(props, { emit }) {
    const { meta, resourceType } = useResource(props, props.resource);

    const updateData = (data) => {
      emit('updateData', data);
    };

    return {
      meta,
      resourceType,
      updateData,
    };
  },
};
</script>
